import React, {useMemo, useState} from "react";
import {
    Container,
    Row, 
    Col,
    InputGroup,
    InputGroupAddon,
    Input,
    Button,
    Badge,
    Collapse,
    Card,
    CardBody,
    CardFooter,
    Spinner,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter
} from 'reactstrap'
import { useTranslation } from "react-i18next";
import { Switch, Route, useRouteMatch, Redirect, useHistory } from "react-router-dom";
import bootbox from "../../components/Bootbox";
import {useStripe} from '@stripe/react-stripe-js';
import AsyncSelect from "react-select/async";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {useFormik} from 'formik';
import * as Yup from 'yup';
import { useModalsDispatch, OPEN_PREVIEW } from '../../context/modals';

import MainLayout from '../../layouts/MainLayout'
import { PageHeader } from '../../components/PageHeader'
import CustomButton from '../../components/Button'
import { Questionare } from '../PublicForm';
import ImagePlaceholder from '../../images/templates/placeholder.jpg'
import { useInfiniteTemplateList, useInfiniteRequestedTemplateList, useDeleteRequestCustomTemplate } from '../../api/hooks/templates'
import { getPrice } from '../../utils'
import useDebounce from '../../hooks/useDebounce'
import UncontrolledTooltip from "reactstrap/lib/UncontrolledTooltip";
import { fetcher } from "../../api/client";
import { fetchCategoryList } from "../../api/actions/categories";
import { useCategoryList } from "../../api/hooks/categories";
import { useProfile } from "../../api/hooks/profile";
import { useCreateContract } from "../../api/hooks/contracts";
import RequestTemplateModal from '../../components/RequestTemplateModal'

import { CreateContractFromQuestionaire, TemplateFolder } from "./TemplateCatalog";


export function MyTemplatesList() {

  return (
      <div style={{minHeight: 3 * 300}}>
        <Container className="p-4 d-flex justify-content-end">
          <RequestTemplateModal 
            // onSuccess={handleAddTemplate}
          />
        </Container>
        <TemplatesFolderContainer 
          label="Borradores"
          sortBy="updatedAt"
          defaultIsOpen={true}
        />
        <TemplatesFolderContainer 
          label="Personalizadas"
          sortBy="updatedAt"
          pluginType="custom"
          defaultIsOpen={false}
        />
        <TemplatesFolderContainer 
          label="Compradas"
          sortBy="updatedAt"
          pluginType="premium"
          defaultIsOpen={false}
        />
        <TemplatesFolderContainer 
          label="Gratis"
          sortBy="updatedAt"
          pluginType="free"
          defaultIsOpen={false}
        />
        <RequestedTemplatesFolderContainer 
          label="Solicitudes de Plantilla"
          defaultIsOpen={true}
        />
        
      </div>
  )
}



export function TemplatesFolderContainer({ label, jurisdiction, category, type = 'free', populate = 'relatedContracts', search, searchExact, sortBy = 'type', pluginType, defaultIsOpen }) {
  const [list, setList] = useState([]);
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const [isQuestionaireOpen, setIsQuestionaireOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(false);
  const modalsDispatch = useModalsDispatch();
  const { profile }  = useProfile()
  // const searchExact = query.get('searchExact')
  const params = useMemo(() => ({
    perPage: 20,
    page: currentPage,
    jurisdiction,
    category,
    populate,
    type,
    search,
    searchExact,
    pluginType: pluginType,
    onlyTemplates: false,
    isPlaylist: false,
    sortBy
  }), [currentPage, jurisdiction, category, type, populate, search, searchExact, sortBy, pluginType])
  const stripe = useStripe()
  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } = useInfiniteTemplateList(params, {
    onSuccess: (payload) => {
      setList(payload?.pages?.flatMap?.(p => p.data) ?? [])
    },
    getNextPageParam: ({ numPages, page }) => (Number(page) < Number(numPages) ? Number(page) + 1 : false),
  })

  const handleEdit = (template) => {
    history.push(`/templates/${template._id}/edit`)
  }
  const handlePreview = (template) => {
    modalsDispatch({ type: OPEN_PREVIEW, template: { ...template, previewType: 'owned' }, center: true })
  }
  
  const handleUse = async (template = {}, disabled) => {
    if (!template) return;
    const templateId = template?._id;
    if (template.isTestament) {
      history.push(`/templates/${templateId}/testaments/create`)
    }else if (!template.questions?.length) {
      history.push(`/templates/${templateId}/documents/create`)
    } else {
      setSelectedTemplate(template)
      setIsQuestionaireOpen(true)
    } 
  }

  const toggleQuestionaire = () => {
    setIsQuestionaireOpen(isOpen => !isOpen)
  }



  return (
    <>      
      <TemplateFolder 
        name={label} 
        count={data?.pages?.[0]?.total} 
        isLoading={isLoading} 
        isOwned={true}
        defaultIsOpen={defaultIsOpen}
        isFetchingNextPage={isFetchingNextPage} 
        templateList={list} 
        onEdit={handleEdit}
        onPreview={handlePreview}
        onUse={handleUse}
      />
      <CreateContractFromQuestionaire 
        isOpen={isQuestionaireOpen}
        questions={selectedTemplate.questions}
        templateId={selectedTemplate.templateId ?? selectedTemplate._id}
        toggle={toggleQuestionaire}
      />
    </>
  )
}

export function RequestedTemplatesFolderContainer({ label, jurisdiction, category, type = 'free', populate = 'relatedContracts', search, searchExact, sortBy = 'type', pluginType }) {
  const [list, setList] = useState([]);
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTemplate, setSelectedTemplate] = useState(false);
  const modalsDispatch = useModalsDispatch();
  const { profile }  = useProfile()
  // const searchExact = query.get('searchExact')
  const params = useMemo(() => ({
    perPage: 20,
    page: currentPage,
    jurisdiction,
    category,
    populate,
    type,
    search,
    searchExact,
    pluginType: pluginType,
    onlyTemplates: false,
    isPlaylist: false,
    sortBy
  }), [currentPage, jurisdiction, category, type, populate, search, searchExact, sortBy, pluginType])
  const stripe = useStripe()
  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } = useInfiniteRequestedTemplateList(params, {
    onSuccess: (payload) => {
      console.log({payload})
      setList(payload?.pages?.flatMap?.(p => p.data) ?? [])
    },
    getNextPageParam: ({ numPages, page }) => (Number(page) < Number(numPages) ? Number(page) + 1 : false),
  })
  const { mutate } = useDeleteRequestCustomTemplate()

  const handleEdit = (template) => {
    history.push(`/templates/${template._id}/edit`)
  }
  const handleDelete = async (template) => {
    const resp = await bootbox.confirm('¿Estás seguro que quieres eliminar la solicitud?')
    if (!resp) return;
    mutate({
      requestTemplateId: template._id
    })
  }
  const handlePreview = (template) => {
    modalsDispatch({ type: OPEN_PREVIEW, template: { ...template, previewType: 'owned' }, center: true })
  }
  
  const handleUse = async (template = {}, disabled) => {
    if (!template) return;
    const templateId = template?._id;
    if (template.isTestament) {
      history.push(`/templates/${templateId}/testaments/create`)
    }else if (!template.questions?.length) {
      history.push(`/templates/${templateId}/documents/create`)
    } else {
      setSelectedTemplate(template)
    } 
  }

  // if (!list.length) return null;

  return (
    <>      
      <TemplateFolder 
        name={label} 
        count={data?.pages?.[0]?.total} 
        isLoading={isLoading} 
        isOwned={true}
        isRequestedTemplate
        isFetchingNextPage={isFetchingNextPage} 
        templateList={list} 
        onDelete={handleDelete}
        // onEdit={handleEdit}
        // onPreview={handlePreview}
        // onUse={handleUse}
      />
    </>
  )
}
